import { styled } from '@mui/material'
import type { PropsWithChildren } from 'react'
import { useEffect, useState } from 'react'

import H4 from '@/components/H4'

const ExpandableSubSectionHeading = styled('div')`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
`

const ExpandableSubSectionIcon = styled('div')<{ $expanded: boolean }>`
  width: 40px;
  height: 40px;
  rotate: ${({ $expanded }) => ($expanded ? '270deg' : '180deg')};
  overflow: hidden;

  img {
    width: 40px;
    height: 40px;
  }
`

const ExpandableSubSectionTitle = styled(H4)`
  color: #34bebd;
`

const ExpandableSubSectionContent = styled('div')`
  position: relative;
  padding: 15px 0;
`

interface ExpandableSubSectionProps {
  heading: string
  isExpanded?: boolean
}

export type Props = PropsWithChildren<ExpandableSubSectionProps>

const ExpandableSubSection = ({ heading, isExpanded, children }: Props) => {
  const [expanded, setExpanded] = useState<boolean>(false)

  const handleToggle = () => setExpanded(!expanded)

  useEffect(() => {
    if (isExpanded !== undefined) {
      setExpanded(isExpanded)
    }
  }, [isExpanded])

  return (
    <div>
      <ExpandableSubSectionHeading onClick={handleToggle}>
        <ExpandableSubSectionIcon $expanded={expanded}>
          <img src="/assets/svg/collapse.svg" alt="chevron" />
        </ExpandableSubSectionIcon>
        <ExpandableSubSectionTitle>{heading}</ExpandableSubSectionTitle>
      </ExpandableSubSectionHeading>
      {expanded && <ExpandableSubSectionContent>{children}</ExpandableSubSectionContent>}
    </div>
  )
}

export default ExpandableSubSection
